export default __webpack_public_path__ + "static/media/pikachu_with_hat.0cec442e.png";